import React, { useState, useEffect, useReducer } from "react";
import { Link, useLocation } from "react-router-dom";
import { IMAGES } from "../constants/theme";
import Collapse from "react-bootstrap/Collapse";
import { MenuListArray2 } from "./MenuListArray2";
import Modal from "react-modal";
import DotenvConfig from "../constants/envConfig";

// --- Vapi nav button (superseded by the Clarion voice agent embed in
// public/index.html). Kept commented out so it can be switched back on.
// import VapiButton from "../components/VapiButton/VapiButton";
// import axios from "axios";

Modal.setAppElement("#root");

// const BASE_URL = process.env.REACT_APP_BASE_URL;
// const VAPI_KEY = process.env.REACT_APP_VAPI_KEY;
// const VAPI_AGENT_ID = process.env.REACT_APP_VAPI_AGENT_ID;

// const AssistantMap = {
//   AU: "de0d229b-b27b-45e1-986d-25edf9f79a8b",
//   US: "ab55b9e7-ce77-46f7-9a84-faa9f99f2361",
//   // "UK": "6d32e147-2a62-405a-b517-9c246518cbe4",
//   UK: "c2adc474-9403-481d-82a4-387c1fd149dd",
// };

const Header2 = () => {
  const [headerFix, setHeaderFix] = useState(false);
  const location = useLocation();
  const [activeMenu, setActiveMenu] = useState("");
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  // Geo lookup that picked the Vapi assistant — see the commented block above.
  // const [assistantId, setAssistantId] = useState(AssistantMap.UK);
  //
  // useEffect(() => {
  //   const getCountry = async () => {
  //     try {
  //       const response = await axios.get(`${BASE_URL}/automation/ip`);
  //       const country = response.data.country;
  //       console.log(country, "COUNTRY");
  //       if (country && AssistantMap[country]) {
  //         setAssistantId(AssistantMap[country]);
  //       } else {
  //         setAssistantId(AssistantMap.UK);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching location:", error);
  //       setAssistantId(AssistantMap.UK);
  //     }
  //   };
  //
  //   getCountry();
  // }, []);

  // Sticky header logic
  useEffect(() => {
    const handleScroll = () => setHeaderFix(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Login modal and localStorage check (immediate mount effect)
  useEffect(() => {
    const loggedIn = localStorage.getItem("isLoggedIn_d");
    if (loggedIn === "true") {
      setIsLoggedIn(true);
      //setIsModalOpen(true);
    } else {
      setIsModalOpen(true);
    }
  }, []);

  // Set sidebar class toggle
  useEffect(() => {
    const mainMenu = document.getElementById("OpenMenu");
    if (mainMenu) {
      mainMenu.classList.toggle("show", sidebarOpen);
    }
  }, [sidebarOpen]);

  // Reducer for menu handling
  const reducer = (prev, next) => ({ ...prev, ...next });
  const initialState = { active: "", activeSubmenu: "" };
  const [state, setState] = useReducer(reducer, initialState);

  const handleMenuActive = (status) => {
    setState({ active: state.active === status ? "" : status });
  };

  const handleSubmenuActive = (status) => {
    setState({ activeSubmenu: state.activeSubmenu === status ? "" : status });
  };

  // Set active menu based on path
  useEffect(() => {
    MenuListArray2.forEach((item) => {
      if (item.to === location.pathname) {
        setActiveMenu(item.title);
      }
      item.content?.forEach((sub) => {
        if (sub.to === location.pathname) {
          setActiveMenu(item.title);
        }
      });
    });
  }, [location.pathname]);

  const handleLogin = () => {
    const hardcodedUsername = DotenvConfig.USERNAME;
    const hardcodedPassword = DotenvConfig.PASSWORD;

    if (username === hardcodedUsername && password === hardcodedPassword) {
      setIsLoggedIn(true);
      setIsModalOpen(false);
      localStorage.setItem("isLoggedIn_d", "true");
    } else {
      alert("Invalid username or password");
    }
  };

  return (
    <>
      {/* Login Modal */}
      <Modal
        isOpen={isModalOpen}
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEsc={false}
        style={{
          overlay: { backgroundColor: "rgba(0,0,0,1)", zIndex: 100000 },
          content: {
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            padding: "20px",
            width: "400px",
            textAlign: "center",
          },
        }}
      >
        <input
          type="text"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          style={{ marginBottom: 10, padding: 10, width: "100%" }}
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={{ marginBottom: 10, padding: 10, width: "100%" }}
        />
        <button
          onClick={handleLogin}
          style={{
            padding: 10,
            width: "100%",
            background: "#a00121",
            color: "#fff",
            border: "none",
          }}
        >
          Login
        </button>
      </Modal>

      <header
        className="site-header mo-left header header-transparent style-2"
        style={{ zIndex: 100 }}
      >
        <div
          className={`sticky-header main-bar-wraper navbar-expand-lg ${headerFix ? "is-fixed" : ""}`}
        >
          <div className="main-bar clearfix">
            <div className="container clearfix">
              <div className="logo-header mostion logo-light">
                <Link to="/">
                  <img src={IMAGES.logoWhite} alt="logo" />
                </Link>
              </div>
              <div className="logo-header mostion logo-dark">
                <Link to="/">
                  <img className="select_logo" src={IMAGES.logo} alt="logo" />
                </Link>
              </div>
              <button
                className={`navbar-toggler navicon justify-content-end ${sidebarOpen ? "open" : "collapsed"}`}
                onClick={() => setSidebarOpen(!sidebarOpen)}
              >
                <span></span>
                <span></span>
                <span></span>
              </button>
              <div className="extra-nav">
                <div className="extra-cell">
                  {/* Clarion voice agent injects its call button in here.
                      Kept empty and unconditional so React never reconciles
                      over the injected node — see public/index.html. */}
                  <div id="clarion-mount" />
                  {/* Previous Vapi button — replaced by the embed above.
                      <VapiButton
                        vapiKey={VAPI_KEY}
                        vapiAgentId={assistantId ?? VAPI_AGENT_ID}
                      /> */}
                  {location.pathname === "/" && (
                    <Link
                      to="https://wa.me/+447460641250"
                      className="btn btn-skew appointment-btn d-xl-block d-none"
                    >
                      <span>
                        <i className="fab fa-whatsapp" />
                      </span>
                    </Link>
                  )}
                </div>
              </div>

              <div
                id="navbarNavDropdown"
                className={`header-nav navbar-collapse collapse justify-content-end ${sidebarOpen ? "show" : ""}`}
              >
                <div className="logo-header logo-dark">
                  <Link to="/">
                    <img src={IMAGES.logo} alt="logo" />
                  </Link>
                </div>
                <ul className="nav navbar-nav navbar navbar-left">
                  {MenuListArray2.map((item, idx) =>
                    item.classChange !== "sub-menu-down" ? (
                      <li
                        key={idx}
                        className={`${item.classChange} ${item.title === activeMenu ? "active" : ""}`}
                      >
                        <Link to={item.to}>{item.title}</Link>
                      </li>
                    ) : (
                      <li
                        key={idx}
                        className={`${item.classChange} ${state.active === item.title ? "open active" : ""} ${item.title === activeMenu ? "active" : ""}`}
                      >
                        <Link
                          to="#"
                          onClick={() => handleMenuActive(item.title)}
                        >
                          {item.title}
                        </Link>
                        <Collapse in={state.active === item.title}>
                          <ul className="sub-menu">
                            {item.content?.map((sub, subIdx) => (
                              <li
                                key={subIdx}
                                className={`${state.activeSubmenu === sub.title ? "open" : ""}`}
                              >
                                {sub.content?.length > 0 ? (
                                  <>
                                    <Link
                                      to={sub.to}
                                      onClick={() =>
                                        handleSubmenuActive(sub.title)
                                      }
                                    >
                                      {sub.title}
                                      <i className="fa fa-angle-right" />
                                    </Link>
                                    <Collapse
                                      in={state.activeSubmenu === sub.title}
                                    >
                                      <ul className="sub-menu">
                                        {sub.content.map((deep, deepIdx) => (
                                          <li key={deepIdx}>
                                            <Link to={deep.to}>
                                              {deep.title}
                                            </Link>
                                          </li>
                                        ))}
                                      </ul>
                                    </Collapse>
                                  </>
                                ) : (
                                  <Link to={sub.to}>{sub.title}</Link>
                                )}
                              </li>
                            ))}
                          </ul>
                        </Collapse>
                      </li>
                    ),
                  )}
                </ul>
                <div className="dz-social-icon">
                  <ul>
                    <li>
                      <Link
                        target="_blank"
                        to="https://www.facebook.com/keepmefitclub"
                      >
                        <i className="fab fa-facebook-f" />
                      </Link>
                    </li>
                    <li>
                      <Link
                        target="_blank"
                        to="https://www.instagram.com/keepmefitclub"
                      >
                        <i className="fab fa-instagram" />
                      </Link>
                    </li>
                    <li>
                      <Link target="_blank" to="https://wa.me/+447460641250">
                        <i className="fab fa-whatsapp" />
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header2;
